import { Stack } from '@/core/blocks';
import { HtmlMarkup, Typography } from '@/core/ui';
import type { IPageInfo } from '@/types';

type Props = { data: IPageInfo };

export const Slide1 = ({ data }: Props) => {
  const { title, description, image_one, image_three, image_two } = data;

  return (
    <div className='h-screen bg-content1 relative'>
      <div className='absolute top-0 left-4'>
        <Stack upperClass='w-[52px] h-[294px]' lowerClass='w-[52px] h-[87px]' />
      </div>
      <div className='flex h-full space-x-28'>
        <div className='pl-48 py-16'>
          <Typography className='text-chalk text-[30px] leading-[28.5px] tracking-[1.5px]'>
            {title}
          </Typography>

          <div className='w-full h-full flex space-x-12 mt-20'>
            <div className='w-[360px] h-[768px]'>
            {image_one.path ? (
              <img
              src={image_one.path}
              alt={image_one.caption || ''}
              className='w-full h-full object-cover'
              />
            ) : null}
            </div>
            <div className='flex flex-col space-y-8 max-w-[366px] mt-20'>
              <img
                src='/history/slide1/president-logo.svg'
                alt={'logo'}
                className='w-[62px] h-[82px] object-cover'
              />
              <Typography className='text-chalk uppercase font-semibold text-[75px] leading-[70.5px] tracking-[3.5px]'>
                {title}
              </Typography>
              <div className='flex items-center'>
                <div className='h-[8.5px] w-[41px] bg-olive' />
                <div className='h-[8.5px] w-[41px] bg-danger' />
              </div>
              <HtmlMarkup className='text-chalk font-light text-[26px] leading-[29.9px] tracking-[1.3px]'>
                {description}
              </HtmlMarkup>
            </div>
          </div>
        </div>
        <div className='flex flex-col justify-between h-full'>
          <div className="w-[480px] h-[480px]">
          {image_two.path ? (
          <img
            src={image_two.path}
            alt={image_two.caption || ''}
            className='w-full h-full object-cover'
          />
        ) : null}
          </div>
          <div className='ml-20 flex space-x-7'>
            <div className="w-[504px] h-[504px]">
            {image_three.path ? (
              <img
                src={image_three.path}
                alt={image_three.caption || ''}
                className='w-full h-full object-cover'
              />
            ) : null}
            </div>
            <div className='max-w-[160px]'>
              <HtmlMarkup className='text-chalk font-light text-[26px] leading-[29.9px] tracking-[1.3px]'>
                {image_three.caption}
              </HtmlMarkup>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
